import { PageHero } from '@components/common';

export default function PrivacyPolicyPage() {
  return (
    <>
      <PageHero
        title="Privacy Policy"
        eyebrow="Legal"
        seoTitle="Privacy Policy | The CISO Network"
        seoDescription="Our privacy policy explains how we collect, use, and protect your personal information."
      />

      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="prose prose-lg max-w-none text-muted-foreground">
            <p className="text-sm text-muted-foreground mb-8">Last updated: January 2026</p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              1. Introduction
            </h2>
            <p>
              The CISO Network (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is committed to
              protecting your privacy. This Privacy Policy explains how we collect, use, disclose,
              and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              2. Information We Collect
            </h2>
            <p>We may collect information about you in a variety of ways, including:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>
                <strong>Personal Data:</strong> Name, email address, phone number, company name, and
                job title when you contact us or sign up for our services.
              </li>
              <li>
                <strong>Usage Data:</strong> Information about how you use our website, including IP
                address, browser type, pages visited, and time spent.
              </li>
            </ul>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              3. How We Use Your Information
            </h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Provide and maintain our services</li>
              <li>Respond to your inquiries and requests</li>
              <li>Send you marketing communications (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              4. Data Security
            </h2>
            <p>
              We implement appropriate technical and organisational measures to protect your
              personal data against unauthorised access, alteration, disclosure, or destruction.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              5. Your Rights
            </h2>
            <p>Under GDPR and other applicable laws, you have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Request restriction of processing</li>
              <li>Data portability</li>
            </ul>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              6. Contact Us
            </h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <p className="mt-4">
              <strong>Email:</strong> privacy@thecisonetwork.com
              <br />
              <strong>Company:</strong> The CISO Network Ltd, company number 17182533
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
